import type { Practitioner, Reference } from "@medplum/fhirtypes";
import { PRACTITIONER_ENTITY_ID_SYSTEM } from "@repo/api";

export function practitionerDomainId(reference: Reference | undefined): string | undefined {
  if (reference?.identifier?.system === PRACTITIONER_ENTITY_ID_SYSTEM && reference.identifier.value) {
    return reference.identifier.value;
  }
  return undefined;
}

export function optimisticPractitionerReference(practitionerId: string): Reference<Practitioner> {
  return { identifier: { system: PRACTITIONER_ENTITY_ID_SYSTEM, value: practitionerId } };
}
